import { createLogger } from '@aviv-unified-frontend/runtime/monitoring';
import { MFE_IDENTIFIER } from '@price-pages-agency-cards/src/constants';
import pkg from '../../../package.json';
export const logger = createLogger({
    name: MFE_IDENTIFIER,
    version: Number(pkg.version.split('.')[0]),
});
